"use client";

import { AnimatePresence, motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { usePrivacyNoticeVisible, markPrivacyNoticeAcknowledged } from "@/lib/usePrivacyNoticeVisible";

export function PrivacyNotice() {
  const visible = usePrivacyNoticeVisible();

  function accept() {
    markPrivacyNoticeAcknowledged();
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          role="dialog"
          aria-label="Aviso de privacidade"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-4 bottom-4 z-[80] mx-auto flex max-w-xl flex-col gap-4 rounded-lg border border-line bg-bg-raised p-5 shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:gap-5"
        >
          <ShieldCheck className="hidden h-8 w-8 shrink-0 text-accent-lime sm:block" aria-hidden />
          <p className="text-sm text-text-secondary">
            Usamos cookies essenciais para o funcionamento do site e, com seu consentimento,
            tratamos os dados que você envia pelo formulário de cadastro, conforme a nossa{" "}
            <a href="/privacidade" className="text-accent-lime underline underline-offset-2 hover:text-accent-lime-dim">
              Política de Privacidade
            </a>
            .
          </p>
          <div className="flex shrink-0 items-center gap-3 sm:flex-col sm:items-stretch">
            <button
              type="button"
              onClick={accept}
              className="rounded-md bg-accent-lime px-5 py-2.5 text-sm font-medium text-ink-black transition-colors hover:bg-accent-lime-dim"
            >
              Entendi
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
